var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 6C21 7.933 19.433 9.5 17.5 9.5C16.3127 9.5 15.2635 8.9088 14.6306 8.00472L9.82058 10.8908C9.93696 11.2393 10 11.6123 10 12C10 12.3877 9.93696 12.7607 9.82058 13.1092L14.6306 15.9953C15.2635 15.0912 16.3127 14.5 17.5 14.5C19.433 14.5 21 16.067 21 18C21 19.933 19.433 21.5 17.5 21.5C15.567 21.5 14 19.933 14 18C14 17.6123 14.063 17.2393 14.1794 16.8907L9.36937 14.0047C8.73654 14.9088 7.68731 15.5 6.5 15.5C4.567 15.5 3 13.933 3 12C3 10.067 4.567 8.5 6.5 8.5C7.68731 8.5 8.73655 9.09121 9.36937 9.9953L14.1794 7.10926C14.063 6.76069 14 6.38771 14 6C14 4.067 15.567 2.5 17.5 2.5C19.433 2.5 21 4.067 21 6ZM17.5 8.5C18.8807 8.5 20 7.38071 20 6C20 4.61929 18.8807 3.5 17.5 3.5C16.1193 3.5 15 4.61929 15 6C15 7.38071 16.1193 8.5 17.5 8.5ZM6.5 14.5C7.88071 14.5 9 13.3807 9 12C9 10.6193 7.88071 9.5 6.5 9.5C5.11929 9.5 4 10.6193 4 12C4 13.3807 5.11929 14.5 6.5 14.5ZM20 18C20 19.3807 18.8807 20.5 17.5 20.5C16.1193 20.5 15 19.3807 15 18C15 16.6193 16.1193 15.5 17.5 15.5C18.8807 15.5 20 16.6193 20 18Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.04336323b3be33c43f7217efb9159c73.svg";
export { ForwardRef as ReactComponent };